{
  "title": "Pulse Wave",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "3rd-level evocation (dunamancy)",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self (30-foot cone)",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You create intense pressure, unleash it in a 30-foot cone, and decide whether the pressure pulls or pushes creatures and objects. Each creature in that cone must make a Constitution saving throw. A creature takes 6d6 force damage on a failed save, or half as much damage on a successful one. And every creature that fails the save is either pulled 15 feet toward you or pushed 15 feet away from you, depending on the choice you made for the spell.",
    "In addition, unsecured objects that are completely within the cone are likewise pulled or pushed 15 feet.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d6 and the distance pulled or pushed increases by 5 feet for each slot level above 3rd."
  ],
  "spellLists": ["eldritch-knight", "wizard"]
}
